export default __webpack_public_path__ + "static/media/buildings_only.c8a55bfa.svg";